import { List, Typography, Image } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as ShopIcon } from 'assets/icons/shop.svg';
import { ReactComponent as FactoryIcon } from 'assets/icons/factory.svg';
import classname from 'classnames';
import classes from './Style.module.scss';

export default function ProductListItem({
  image,
  itemNo,
  supplier,
  factory,
  name,
  extra,
  children = null,
  className,
  bordered,
  order
}: any) {
  return (
    <List.Item
      className={classname(classes.listItem, className, {
        [classes.bordered]: bordered
      })}
    >
      <div
        className={classname(classes.card, {
          [classes.cardOrder]: !!order
        })}
        data-no={order}
      >
        <div>
          <List.Item.Meta
            avatar={
              <Image
                preview={false}
                width={80}
                height={40}
                src={image}
                style={{ objectFit: 'contain' }}
              />
            }
            title={
              <span className={classes.group}>
                <Typography.Title className={classes.title} level={5}>
                  {name}
                </Typography.Title>
                <p className={classes.caption}>{itemNo}</p>
              </span>
            }
            description={
              <span className={classes.group}>
                <span className={classes.inline}>
                  <Icon component={ShopIcon} />
                  <p className={classes.caption}>{supplier}</p>
                </span>
                <span className={classes.inline}>
                  <Icon component={FactoryIcon} />
                  <p className={classes.caption}>{factory}</p>
                </span>
              </span>
            }
          />
          {extra}
        </div>
      </div>
      {children}
    </List.Item>
  );
}
// ProductListItem.propTypes = {
//   image: PropTypes.string.isRequired,
//   itemNo: PropTypes.string.isRequired,
//   supplier: PropTypes.string.isRequired,
//   factory: PropTypes.string.isRequired,
//   name: PropTypes.string.isRequired,
//   bordered: PropTypes.bool,
//   extra: PropTypes.node,
//   children: PropTypes.node,
//   className: PropTypes.string,
//   order: PropTypes.oneOf([PropTypes.number, PropTypes.any])
// };

// ProductListItem.defaultProps = {
//   bordered: true,
//   extra: null,
//   children: null,
//   className: '',
//   order: ''
// };
